module.exports = __webpack_public_path__ + "img/FGr_Trinkwasser_B.cf6763c1.svg";